/**
 * Typography Design Tokens
 */

export const typography = {
  fontFamily: {
    primary: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, "Noto Sans SC", "PingFang SC", "Microsoft YaHei", "Heiti SC", sans-serif',
    mono: '"JetBrains Mono", "Fira Code", Consolas, "Courier New", monospace',
  },

  // Role-based type scale (preferred — use these in new components)
  typeRoles: {
    display:   { size: '36px', weight: 700, lineHeight: 1.15, letterSpacing: '-0.5px' },
    pageTitle: { size: '28px', weight: 600, lineHeight: 1.2,  letterSpacing: '-0.3px' },
    section:   { size: '22px', weight: 600, lineHeight: 1.25, letterSpacing: '-0.2px' },
    cardTitle: { size: '15px', weight: 600, lineHeight: 1.35, letterSpacing: '0' },
    body:      { size: '14px', weight: 400, lineHeight: 1.55, letterSpacing: '0' },
    bodySm:    { size: '13px', weight: 400, lineHeight: 1.5,  letterSpacing: '0' },
    caption:   { size: '12px', weight: 500, lineHeight: 1.4,  letterSpacing: '0.3px' },
    overline:  { size: '11px', weight: 600, lineHeight: 1.35, letterSpacing: '0.5px' },
    badge:     { size: '11px', weight: 600, lineHeight: 1.2,  letterSpacing: '0.3px' },
  },

  // Generic size scale (backward compat — prefer typeRoles for new code)
  fontSize: {
    xs: '11px',
    sm: '12px',
    base: '14px',
    md: '16px',
    lg: '18px',
    xl: '20px',
    '2xl': '24px',
    '3xl': '32px',
  },

  fontWeight: {
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },

  lineHeight: {
    tight: 1.2,
    snug: 1.25,
    default: 1.35,
    normal: 1.5,
    body: 1.55,
    relaxed: 1.6,
    loose: 1.8,
  },
} as const;

export type TypographyToken = typeof typography;
